export const BASE_PATH = '/homemade-food-delivery';
export const LINKS_BLOCK_LIMIT = 10;

export enum DietaryTags {
  VEGETARIAN = 'Vegetarian',
  VEGAN = 'Vegan',
  GLUTEN_FREE = 'Gluten Free',
  DAIRY_FREE = 'Dairy Free',
  LOW_FODMAP = 'Low FODMAP',
  PALEO = 'Paleo',
  WHOLE30 = 'Whole 30',
  HALAL = 'Halal',
  ORGANIC = 'Organic',
  COMPOSTABLE = 'Compostable',
  KOSHER = 'Kosher',
}

export const DIETARY_TAG_DISPLAY_ORDER = [
  DietaryTags.COMPOSTABLE,
  DietaryTags.VEGAN,
  DietaryTags.VEGETARIAN,
  DietaryTags.DAIRY_FREE,
  DietaryTags.GLUTEN_FREE,
  DietaryTags.PALEO,
  DietaryTags.WHOLE30,
  DietaryTags.LOW_FODMAP,
  DietaryTags.ORGANIC,
  DietaryTags.HALAL,
  DietaryTags.KOSHER,
];

// TODO: We should probably move these to /shared so that they're accessible by both /shef-web and /shef-next
export const tempDietaryTagMappings: Record<string, DietaryTags> = {
  vegetarian: DietaryTags.VEGETARIAN,
  vegan: DietaryTags.VEGAN,
  gluten_free: DietaryTags.GLUTEN_FREE,
  dairy_free: DietaryTags.DAIRY_FREE,
  paleo: DietaryTags.PALEO,
  low_fodmap: DietaryTags.LOW_FODMAP,
  whole30: DietaryTags.WHOLE30,
  halal: DietaryTags.HALAL,
  organic: DietaryTags.ORGANIC,
  compostable: DietaryTags.COMPOSTABLE,
  // Fixes the case when the dietary filter is camelCase instead of snake_case
  glutenFree: DietaryTags.GLUTEN_FREE,
  dairyFree: DietaryTags.DAIRY_FREE,
  lowFodmap: DietaryTags.LOW_FODMAP,
  kosher: DietaryTags.KOSHER,
};
